import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import {
  useRive,
  Layout,
  Fit,
  Alignment,
  useViewModel,
  useViewModelInstance,
  useViewModelInstanceTrigger,
  useViewModelInstanceEnum,
} from '@rive-app/react-canvas';
import { useAssets } from '../components/AssetHandler';
import { useSound } from '../components/SoundHandler';
import { DEVICE_PIXEL_RATIO } from '../game-engine';

export const BonusStageModal = ({
  onTrigger,
  onDismiss,
}: {
  onTrigger: () => void,
  onDismiss: () => void
}) => {
  const { assets } = useAssets()
  const { play } = useSound()

  const { rive, RiveComponent } = useRive({
    buffer: assets.riveFiles['bonus-round'],
    artboard: 'bonus-round',
    stateMachines: 'state',
    autoplay: true,
    autoBind: true,
    layout: new Layout({
      fit: Fit.Cover,
      alignment: Alignment.Center,
    }),
  }, { customDevicePixelRatio: DEVICE_PIXEL_RATIO });

  const viewModel = useViewModel(rive, { name: 'vm' });
  const viewModelInstance = useViewModelInstance(viewModel, { useDefault: true, rive });
  const { trigger: triggerShow } = useViewModelInstanceTrigger('show', viewModelInstance);
  const { trigger: triggerHide } = useViewModelInstanceTrigger('hide', viewModelInstance);

  const hasTriggeredRef = useRef(false);
  const hideTimerRef = useRef<number | null>(null);
  const dismissTimerRef = useRef<number | null>(null);
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    if (!viewModelInstance) {
      return
    }
    if (hasTriggeredRef.current) {
      return
    }

    hasTriggeredRef.current = true;
    play('blinkoTransition');
    triggerShow();

    setTimeout(() => {
      play('blinko');
    }, 200);

    hideTimerRef.current = window.setTimeout(() => {
      triggerHide();
      setIsHiding(true);
      onTrigger();
      dismissTimerRef.current = window.setTimeout(() => {
        onDismiss();
      }, 500);
    }, 1500);
  }, [viewModelInstance]);

  return (
    <div className="fixed z-30 inset-0">
      <motion.div
        className="absolute inset-0 bg-[#0a0523]/40"
        initial={{ opacity: 0 }}
        animate={{ opacity: isHiding ? 0 : 1 }}
        transition={{ duration: 0.3 }}
      />

      <motion.div
        className="absolute inset-0"
        style={{ backdropFilter: 'blur(20px)' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: isHiding ? 0 : 1 }}
        transition={{ duration: 0.3 }}
      />
      
      <div className='relative flex items-center justify-center w-full h-full'>
         <RiveComponent className="w-full h-full" />
      </div>
    </div>
  )
};
